export default __webpack_public_path__ + "static/media/creatinggroups.7726c2e4.svg";